import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomDataGrid } from '../data-grid/CustomDataGrid';
import { useStyles } from '../../theme/styles.helpers';
import { CustomersStyles } from './Customers.Styles';
import { Typography } from '@mui/material';
import { AppstleSubscription } from './Customers';

interface ListRow {
  id: number
  customerEmail: string
  status: string
  paused: string
  isMedical: string
  product: string
  createdAt: string
  pausedOn: string
  cancelledOn: string
}

const AppstleSubscriptions = ({ 
  search,
  subscriptions
}: { 
  search: string;
  subscriptions: AppstleSubscription[];
}) => {
  const styles = useStyles(CustomersStyles, {});
  const { t } = useTranslation();
  const [rows, setRows] = useState<ListRow[]>([]);

  const transformToRow = (subscription: AppstleSubscription): ListRow => {
    
    const [detailsJson] = subscription.contractDetailsJSON ? JSON.parse(subscription.contractDetailsJSON) : [];

    const productTitle = detailsJson?.title || '';

    return {
      id: subscription.id,
      customerEmail: subscription.customerEmail,
      status: t(subscription.status),
      paused: subscription.status === 'paused' ? t('Yes') : t('No'),
      isMedical: productTitle.toLowerCase().includes('rx') ? t('Yes') : t('No'),
      product: productTitle,
      createdAt: new Date(subscription.createdAt).toLocaleString('de-DE'),
      pausedOn: subscription.pausedOn ? new Date(subscription.pausedOn).toLocaleString('de-DE') : '',
      cancelledOn: subscription.cancelledOn ? new Date(subscription.cancelledOn).toLocaleString('de-DE') : '',
    };
  };

  useEffect(() => {
    setRows(subscriptions.map(transformToRow));
  }, [subscriptions]);

  useEffect(() => {
    const filteredRows = subscriptions.map(transformToRow).filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(search.toLowerCase());
        }
        if (typeof value === 'number') {
          return value.toString().includes(search.toLowerCase());
        }
        return false;
      });
    });
    setRows(filteredRows);
  }, [search, subscriptions]);

  const columns = [
    { field: 'customerEmail', headerName: t('E-Mail'), filterable: false, flex: 1 },
    { field: 'status', headerName: t('Status'), filterable: false },
    { field: 'paused', headerName: t('Paused'), filterable: false },
    { field: 'isMedical', headerName: t('Medical'), filterable: false },
    { field: 'createdAt', headerName: t('Created'), filterable: false, flex: 1 },
    { field: 'pausedOn', headerName: t('Paused On'), filterable: false, flex: 1 },
    { field: 'cancelledOn', headerName: t('Cancelled On'), filterable: false, flex: 1 },
    { field: 'product', headerName: t('Product'), filterable: false, flex: 1 },
  ];

  const totalSubs = subscriptions.length;
  const activeSubs = subscriptions.filter((s) => s.status === 'active').length;
  const pausedSubs = subscriptions.filter((s) => s.status === 'paused').length;
  const cancelledSubs = subscriptions.filter((s) => s.status === 'cancelled').length;

  return (
    <Box sx={styles.root}>
      <CustomDataGrid
        columns={columns}
        rows={rows}
        getRowId={(row) => row.id.toString()}
        isCellEditable={() => false}
        isRowSelectable={() => false}
        pagination
        autoPageSize
        sx={styles.row}
        ignoreDiacritics
        initialState={{
          sorting: {
            sortModel: [{ field: 'createdAt', sort: 'desc' }],
          },
        }}
      />
      <Box paddingX={7} display={'flex'} gap={2} alignItems={'center'} justifyContent={'end'}>
        <Typography>
          {t('Total')}: {totalSubs}
        </Typography>
        <Typography>
          {t('Active')}: {activeSubs}
        </Typography>
        <Typography>
          {t('Paused')}: {pausedSubs}
        </Typography>
        <Typography>
          {t('Cancelled')}: {cancelledSubs}
        </Typography>
      </Box>
    </Box>
  );
};

export default AppstleSubscriptions;


